module.exports = __webpack_public_path__ + "images/332179a26ed0375eaf0642cc7d0cb69142.svg";